var HOST = process.env.VUE_APP_URL
// var HOST = "/api";
export default {
  HOST,
  /**
     * @method GET
     * @params banner
     * @return {"status":200, "msg":"success"}
     */
  // 富文本
  getPrivacyAgreementById: HOST + '/sys/muban/getRichById', // 富文本

  getMallClassIndex: HOST + '/app/tMallClass/getMallClassIndex', // 查询分类
  getMallGoodList: HOST + '/app/tMallGoods/getMallGoodList', // 查询商品列表
  getMallGoodById: HOST + '/app/tMallGoods/getMallGoodById', // 查询商品详情
  buyGoodById: HOST + '/app/tMallGoodsLog/buyGood', // 兑换商品
  orderList: HOST + '/app/tMallGoodsLog/listApp', // 兑换商品列表
  getUserData: HOST + '//sys/user/getUserData'// 获取用户信息

}



// WEBPACK FOOTER //
// ./src/plugins/api.js